// framework imports - 1st party
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// lib imports - 3rd party
import moment from "moment";

// app imports
import * as api from "../api";
import Logo from "../icons/logo1.png";
import "../stylesheets/Footer.css";

const Footer = () => {
  const [version, setVersion] = useState("");
  const [commitTime, setCommitTime] = useState("");
  const [privacyPolicyUrl, setPrivacyPolicyUrl] = useState("");
  const location = useLocation();

  useEffect(() => {
    api
      .getBuild()
      .then((x) => {
        if (x && x.build && x.build.version) {
          setVersion(x.build.version);
        } else if (x) {
          setVersion("Unknown");
        }
        if (x && x.git && x.git.commit && x.git.commit.time) {
          setCommitTime(x.git.commit.time);
        }
        if (x && x.allpaidPrivacyPolicyUrl) {
          setPrivacyPolicyUrl(x.allpaidPrivacyPolicyUrl);
        }
      })
      .catch((error) => {
        console.log("Error fetching build info:", error);
        setVersion("Unknown");
        setCommitTime("");
        setPrivacyPolicyUrl("");
      });
  }, []);

  const isNarrowFooter =
    location.pathname.includes("login") ||
    location.pathname.includes("changepasswordpage");

  return (
    <footer
      className={
        isNarrowFooter ? "footer footer--narrow" : "footer footer--wide"
      }
    >
      <div className="footer-main">
        <div className="footer-left">
          <img className="footer-logo" src={Logo} alt="AllPaid" />
          <div className="footer-address">
            7820 Innovation Blvd, Ste 250
            <br />
            Indianapolis, IN 46278-2729
            <br />
            (888) 561-7888
          </div>
        </div>
        <div className="footer-right">
          {privacyPolicyUrl ? (
            <a href={privacyPolicyUrl}>Privacy Policy</a>
          ) : (
            <span>Privacy Policy</span>
          )}
          <br />
          Proview version: {version}
          <br />
          Last Commit:{" "}
          {commitTime && moment(commitTime).isValid()
            ? moment(commitTime).format("M/DD/YYYY h:mm A")
            : "—"}
        </div>
      </div>
      <div className="center-footer">
        &copy; 2007 - {moment().year()} Al AllPaid, Inc. All Rights Reserved.
        (NMLS ID #1434636; Licensed by the Georgia Department of Banking and
        Finance #61205)
      </div>
    </footer>
  );
};

export default Footer;
